import React from 'react';
import styled from 'styled-components';
import { FullPage } from '../components/FullPage';
import { useParams, useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Delete } from '@styled-icons/material/Delete';

import { useTranslation } from 'react-i18next';
import {Button} from '../components/Button';

import {DELETE_POI_MUTATION, GET_POI_QUERY, GetPoiData, ObservationProperties} from '../graphql/pois';
import {sidcToSymbol} from '../utils/symbols';

const StyledDeletePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const DeleteIcon = styled(Delete)`
  color: ${props => props.theme.colors.main};
  height: ${props => props.theme.spacing.default*2}px;
  width: ${props => props.theme.spacing.default*2}px;
`

const UnitSymbolContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing.margin}px;
`;

const UnitSymbol = styled.img`
  height: 5em;
`;

export const DeleteObservationPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { poiId } = useParams();

  const { data: getPoiData, loading: getPoiLoading } = useQuery<GetPoiData>(GET_POI_QUERY, {
    variables: {
      id: poiId
    }
  });

  const properties: ObservationProperties = getPoiData ? JSON.parse(getPoiData.getPoi.properties) : null;

  const [deletePoi, { loading: deleting }] = useMutation(DELETE_POI_MUTATION);

  const onDelete = () => {
    deletePoi({
      variables: { id: poiId }
    })
      .then(() => {
        history.push(`/`)
      })
  }

  return (
    <FullPage
      heading={t('observations.delete')}
      loading={deleting || getPoiLoading}
      closeHandler={() => history.push(`/observations/view/${poiId}`)}
    >
      <StyledDeletePage>
        <h2>{t('observations.delete')}?</h2>
        <UnitSymbolContainer>
          <UnitSymbol src={`data:image/svg+xml;utf8,${properties && sidcToSymbol(properties.sidc, '')}`} />
        </UnitSymbolContainer>
        <p>{properties && properties.description}</p>
        <Button clickHandler={onDelete} size={'lg'}><DeleteIcon /> {t('delete')}</Button>
      </StyledDeletePage>
    </FullPage>
  )
}
